import React, { useEffect, useState } from "react";
import InputField from "../../SharedComponent/Fields/InputField";
import { useTranslation } from "react-i18next";
import SelectField from "../../SharedComponent/Fields/SelectField";
import TextAreaFielD from "../../SharedComponent/Fields/TextareaField";
import { ImagePlus, Upload, X } from "lucide-react";
import { getAttachmentLargeUrl, getAttachmentThumbUrl, getAttachmentDocumentUrl } from "../../utils/attachmentImages";
const Batteries = ({
  formatAttachment,
  handleDeleteAttachment,
  assetAttachments,
  newAsset,
  handleChange,
  warehouses,
  selectedWarehouse,
  handleWarehouseChange,
  warehouseLocationId,
  selectedFiles,
  handleRemoveFile,
  handleFileChange,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="bg-white p-4 shadow-md  ">
        <h2 className="text-xl font-medium mb-3  text-gray-800">
          {" "}
          {t("assetPageHeadings.basics")}
        </h2>
        <div className="grid grid-cols-1  sm:grid-cols-4 gap-2 ">
          {/* Row 1: Manufacturer and Serial Number */}

          <div className="col-span-1 grid grid-cols-1  sm:grid-cols-2 gap-2">
            <div>
              <InputField
                required
                name="manufacturer"
                value={newAsset.manufacturer}
                maxLength={100}
                onChange={handleChange}
                label={t("assets.fields.manufacturer")}
                explanation={t("assets.fields.explanation.manufacturer")}
                placeholder={t("createAsset.placeholder.enterManufacturer")}
              />
            </div>

            <div className="">
              <InputField
                name="type"
                value={newAsset.type}
                onChange={handleChange}
                label={t("assets.fields.type")}
                explanation={t("assets.fields.explanation.type")}
                placeholder={t("createAsset.placeholder.enterType")}
                maxLength={30}
              />
            </div>
          </div>

          <div className="gap-2 col-span-3 grid grid-cols-1 sm:grid-cols-4">
            <SelectField
              name="battery_type"
              value={newAsset.battery_type}
              onChange={handleChange}
              label={t("assets.fields.classification")}
              explanation={t("assets.fields.explanation.classification")}
              placeholder={t("assets.fields.selectClassification")}
              required
              menus={[
                {
                  value: "",
                  option: t("assets.fields.selectClassification"),
                },
                // {
                //   value: 1,
                //   option: t("assets.options.none"),
                // },
                {
                  value: 2,
                  option: t("assets.options.pzs"),
                },
                {
                  value: 3,
                  option: t("assets.options.gel"),
                },
                {
                  value: 4,
                  option: t("assets.options.lithium-ion"),
                },
                {
                  value: 5,
                  option: t("assets.options.starter"),
                },
                {
                  value: 6,
                  option: t("assets.options.waterless"),
                },
                {
                  value: 7,
                  option: t("assets.options.tppl"),
                },
                {
                  value: 8,
                  option: t("assets.options.nimh"),
                },
                {
                  value: 9,
                  option: t("assets.options.battery_others"),
                },
              ]}
              selectClassName={
                !newAsset.battery_type
                  ? "text-gray-400 font-light"
                  : "text-gray-900 font-normal"
              }
            />
            <div>
              <InputField
                required
                name="serial_no"
                value={newAsset.serial_no}
                onChange={handleChange}
                placeholder={t("createAsset.placeholder.enterSerialNumber")}
                label={`${t("assets.fields.machineSerialNo")} `}
                explanation={t("assets.fields.explanation.machineSerialNo")}
                maxLength={100}
              />
            </div>

            <div>
              <InputField
                name="intern_no"
                value={newAsset.intern_no}
                onChange={handleChange}
                maxLength={100}
                // placeholder={t(
                //   "createAsset.placeholder.enterSerialNumber"
                // )}
                placeholder={t("createAsset.placeholders.internNoPlaceholder")}
                // label={`${t("assets.fields.machineSerialNo")} *`}
                label={t("createAsset.placeholders.internNoLabel")}
                // explanation={t(
                //   "assets.fields.explanation.machineSerialNo"
                // )}
                explanation={t("createAsset.placeholders.internNoExplanation")}
              />
            </div>
            <div className="">
              <SelectField
                name="status"
                value={newAsset.status}
                onChange={handleChange}
                label={`${t("assets.fields.status")} *`}
                explanation={t("assets.fields.explanation.status")}
                placeholder={t("createAsset.placeholder.enterStatus")}
                menus={[
                  {
                    value: "",
                    option: t("assets.fields.selectStatus"),
                  },
                  // { value: "Demo", option: t("assets.options.demo") },
                  // { value: "Rental", option: t("assets.options.rental") },
                  { value: "New", option: t("assets.options.new") },
                  { value: "Used", option: t("assets.options.used") },
                  {
                    value: "Short Time Hire",
                    option: t("assets.options.shortTermHire"),
                  },
                  {
                    value: "Demo",
                    option: "Demo",
                  },
                ]}
              />
            </div>
          </div>
        </div>

        {/* Row 3: Status, Country, Zip, and City all in one row */}
        <div className="col-span-2 grid grid-cols-6 gap-2  ">
          <div className="col-span-2">
            <InputField
              required
              name="year_of_manufacture"
              value={newAsset.year_of_manufacture || ""}
              onChange={handleChange}
              label={t("assets.fields.yearOfManufacture")}
              explanation={t("assets.fields.explanation.yearOfManufacture")}
              placeholder={t("createAsset.placeholder.enterYearOfManufacture")}
              type="year"
              maxLength={100}
            />
          </div>

          <div className="flex flex-col col-span-2">
            <InputField
              placeholder={t(
                "createAsset.placeholders.batteryCapacityPlaceholder"
              )}
              label={t("createAsset.placeholders.batteryCapacity")}
              explanation={t(
                "createAsset.placeholders.batteryCapacityExplanation"
              )}
              type="number"
              name="batterycapacity"
              value={newAsset.batterycapacity}
              onChange={handleChange}
              maxLength={8}
              className="p-2 border border-gray-300 gap-2"
            />
          </div>

          <div className="flex flex-col col-span-2">
            <SelectField
              name="battery_voltage"
              value={newAsset.battery_voltage}
              onChange={handleChange}
              label={t("createAsset.placeholders.batteryNominalVoltage")}
              explanation={t(
                "createAsset.placeholders.batteryNominalVoltageExplanation"
              )}
              placeholder={t(
                "createAsset.placeholders.selectNominalVoltagePlaceholder"
              )}
              menus={[
                {
                  value: "",
                  option: t(
                    "createAsset.placeholders.selectNominalVoltagePlaceholder"
                  ),
                },
                { value: "6", option: "6" },
                { value: "8", option: "8" },
                { value: "12", option: "12" },
                { value: "24", option: "24" },
                { value: "36", option: "36" },
                { value: "48", option: "48" },
                { value: "72", option: "72" },
                { value: "80", option: "80" },
                { value: "90", option: "90" },
                { value: "96", option: "96" },
                { value: "120", option: "120" },
              ]}
            />
          </div>

          <div className="col-span-6 grid grid-cols-4 gap-2">
            <div className="flex flex-col">
              <InputField
                //   placeholder={t(
                //     "createAsset.placeholders.batteryLengthPlaceholder"
                //   )}
                //   label={t("createAsset.placeholders.batteryLength")}
                //   explanation={t(
                //     "createAsset.placeholders.batteryLengthExplanation"
                //   )}
                placeholder={t(
                  "createAsset.placeholders.batteryHeightPlaceholder"
                )}
                label={t("createAsset.placeholders.batteryHeightLabel")}
                explanation={t(
                  "createAsset.placeholders.batteryHeightExplanation"
                )}
                type="number"
                name="batteryheight"
                value={newAsset.batteryheight}
                maxLength={8}
                onChange={handleChange}
                className="p-2 border border-gray-300 gap-2"
              />
            </div>

            <div className="flex flex-col">
              <InputField
                placeholder={t(
                  "createAsset.placeholders.batteryLengthPlaceholder"
                )}
                label={t("createAsset.placeholders.batteryLength")}
                explanation={t(
                  "createAsset.placeholders.batteryLengthExplanation"
                )}
                type="number"
                name="batterylength"
                value={newAsset.batterylength}
                maxLength={8}
                onChange={handleChange}
                className="p-2 border border-gray-300 gap-2"
              />
            </div>

            <div className="flex flex-col">
              <InputField
                placeholder={t(
                  "createAsset.placeholders.batteryWidthPlaceholder"
                )}
                label={t("createAsset.placeholders.batteryWidth")}
                explanation={t(
                  "createAsset.placeholders.batteryWidthExplanation"
                )}
                type="number"
                name="batterywidth"
                maxLength={10}
                value={newAsset.batterywidth}
                onChange={handleChange}
                className="p-2 border border-gray-300 gap-2"
              />
            </div>

            <div className="flex flex-col">
              <InputField
                placeholder={t(
                  "createAsset.placeholders.batteryWeigthPlaceholder"
                )}
                label={t("createAsset.placeholders.batteryWeigth")}
                explanation={t(
                  "createAsset.placeholders.batteryWeigthExplanation"
                )}
                type="number"
                name="batteryweight"
                value={newAsset.batteryweight}
                maxLength={8}
                onChange={handleChange}
                className="p-2 border border-gray-300 gap-2"
              />
            </div>
          </div>

          {Array.isArray(warehouses) && warehouses?.length > 0 && (
            <div className="col-span-2">
              <SelectField
                name="warehouse"
                value={selectedWarehouse?.id || warehouseLocationId || ""}
                onChange={(e) => {
                  handleWarehouseChange(e);
                }}
                label={t("createAsset.placeholders.warehouseLabel")}
                explanation={t("createAsset.placeholders.warehouseExplanation")}
                placeholder={t("createAsset.placeholders.warehousePlaceholder")}
                menus={[
                  {
                    value: "",
                    option: t("createAsset.placeholders.warehousePlaceholder"),
                  },
                  ...warehouses.map((warehouse) => {
                    return {
                      value: warehouse.id,
                      option: warehouse.name,
                    };
                  }),
                ]}
              />
            </div>
          )}

          <div>
            <InputField
              required
              name="dealer_street"
              value={newAsset.dealer_street}
              onChange={handleChange}
              maxLength={20}
              label={t("createAsset.placeholders.street")}
              placeholder={t("createAsset.placeholders.streetPlaceholder")}
              explanation={t("createAsset.placeholders.streetExplanation")}
            />
          </div>

          <div>
            <InputField
              required
              name="dealer_city"
              value={newAsset.dealer_city}
              onChange={handleChange}
              label={t("createAsset.placeholders.city")}
              explanation={t("createAsset.placeholders.cityExplanation")}
              // placeholder={t("createAsset.placeholder.enterDealerCity")}
              placeholder={t("createAsset.placeholders.cityPlaceholder")}
              maxLength={50}
            />
          </div>

          <div>
            <InputField
              required
              name="dealer_country"
              value={newAsset.dealer_country}
              onChange={handleChange}
              label={t("createAsset.placeholders.country")}
              explanation={t("createAsset.placeholders.countryExplanation")}
              // placeholder={t(
              //   "createAsset.placeholder.enterDealerCountry"
              // )}
              placeholder={t("createAsset.placeholders.countryPlaceholder")}
              maxLength={50}
            />
          </div>

          <div>
            <InputField
              required
              name="dealer_zip"
              value={newAsset.dealer_zip}
              onChange={handleChange}
              type="number"
              label={t("createAsset.placeholders.zipCode")}
              explanation={t("createAsset.placeholders.zipCodePlaceholder")}
              placeholder={t("createAsset.placeholders.zipCodeExplanation")}
              maxLength={7}
            />
          </div>

          <div className="col-span-6">
            <TextAreaFielD
              name="description"
              value={newAsset.description}
              onChange={handleChange}
              label={t("createAsset.placeholders.additionalDescription")}
              explanation={t(
                "createAsset.placeholders.cityPlaadditionalDescriptionExplanationceholder"
              )}
              placeholder={t(
                "createAsset.placeholders.additionalDescriptionPlaceholder"
              )}
            />
          </div>
        </div>
      </div>

      <div className="bg-white p-4 shadow-md ">
        <h2 className="text-xl font-medium mb-3  text-gray-800">
          {t("assetPageHeadings.media")}
        </h2>
        {console.log("selected files = ", selectedFiles)}
        {selectedFiles?.length > 0 && (
          <div className="space-y-2 mt-2">
            {/* <h4 className=" text-gray-700">Selected Files</h4> */}
            <h6>Selected Media </h6>
            <ul className="space-y-1 flex flex-col gap-3">
              {Array.from(selectedFiles).map((file, index) => (
                <li key={index} className="flex items-center gap-4">
                  {file.type.startsWith("image/") && (
                    <img
                      className="h-10 w-10"
                      alt={`asset image  ${index}`}
                      src={URL.createObjectURL(file)}
                    />
                  )}
                  <a
                    href={URL.createObjectURL(file)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 text-sm font-semibold underline ml-2"
                  >
                    {file.name}
                  </a>
                  <div
                    onClick={() => handleRemoveFile(index)}
                    className="cursor-pointer"
                  >
                    <X className="h-5 w-5 " />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}

        {assetAttachments &&
          Array.isArray(assetAttachments) &&
          assetAttachments?.length > 0 && (
            <div className="flex flex-col gap-2">
              <h6 className="mt-4">Uploaded Media </h6>
              {
                <div className="flex flex-col gap-3">
                  {assetAttachments.map((attachment, index) => {
                    if (attachment?.image) {
                      return (
                        <div key={index} className="flex items-center gap-2">
                          {
                            <img
                              className="h-10 w-10"
                              alt={`asset image  ${index}`}
                              src={getAttachmentThumbUrl(attachment)}
                            />
                          }
                          <a
                            href={getAttachmentLargeUrl(attachment)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className=" text-blue-600 text-sm font-semibold underline ml-2"
                          >
                            {formatAttachment(
                              getAttachmentLargeUrl(attachment)
                            )}
                          </a>
                          <div
                            onClick={() => {
                              handleDeleteAttachment(attachment?.id);
                            }}
                            className="cursor-pointer "
                          >
                            <X className="Cursor-pointer h-5 w-5 " />
                          </div>
                        </div>
                      );
                    } else if (attachment?.document) {
                      return (
                        <div className="flex items-center gap-4  ">
                          <a
                            href={getAttachmentDocumentUrl(attachment)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className=" text-blue-600 text-sm font-semibold underline ml-2"
                          >
                            {formatAttachment(
                              getAttachmentDocumentUrl(attachment)
                            )}
                          </a>
                          <div
                            onClick={() => {
                              handleDeleteAttachment(attachment?.id);
                            }}
                            className="cursor-pointer"
                          >
                            <X className="Cursor-pointer h-5 w-5" />
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
              }
            </div>
          )}

        <div className="my-4">
          <div className="relative">
            <input
              type="file"
              multiple
              onChange={(e) => {
                handleFileChange(e);
              }}
              accept="image/*, .xlsx, .xls, .doc, .docx, .pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/pdf"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
              id="image-upload"
            />
            <label
              htmlFor="image-upload"
              className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 hover:border-gray-400 transition-all duration-200 ease-in-out group"
            >
              <div className="flex flex-col items-center justify-center pt-5 pb-6">
                <div className="flex items-center space-x-2 mb-2">
                  <Upload className="w-6 h-6 text-gray-400 group-hover:text-gray-600 transition-colors" />
                  <ImagePlus className="w-6 h-6 text-gray-400 group-hover:text-gray-600 transition-colors" />
                </div>
                <p className="mb-2 text-sm text-gray-500">
                  <span className="font-semibold">
                    {t("assetPageHeadings.clickToUpload")}
                  </span>
                </p>
                <p className="text-xs text-gray-400">
                  {t("assetPageHeadings.fileSupported")}
                </p>
              </div>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default Batteries;
